import React, { ReactNode, SyntheticEvent } from "react";
import { Link } from "react-router-dom";

import "./button.styles.css";

export interface ButtonProps {
  label: string;
  type?: "link" | "button" | "input";
  layout?: "solid" | "outline" | "icon" | "icon-solid" | "icon-outline";
  onClick?: (event: SyntheticEvent) => void;
  href?: string;
  external?: boolean;
  customClassName?: string;
  icon?: ReactNode;
  colorStyle?: "primary" | "secondary";
  isDisabled?: boolean;
  target?: HTMLAnchorElement["target"];
}

const iconLayouts = ["icon", "icon-solid", "icon-outline"];

const Button = (props: ButtonProps): JSX.Element => {
  const {
    label,
    type,
    customClassName,
    onClick,
    href,
    layout = "solid",
    icon,
    colorStyle,
    isDisabled,
    target,
    external = false,
  } = props;

  const className = `button button-${layout} button-${layout}--${colorStyle} ${
    isDisabled ? `button-${layout}--disabled` : ""
  } ${customClassName}`;

  switch (type) {
    case "button":
      return (
        <button
          className={className}
          onClick={onClick}
          type="button"
          title={label}
          disabled={isDisabled}
        >
          {iconLayouts.includes(layout) ? icon : label}
        </button>
      );
    case "input":
      return (
        <input
          type="submit"
          className={className}
          onClick={onClick}
          value={label}
        />
      );
    default:
      if (external) {
        return (
          <a
            title={label}
            className={className}
            href={href || ""}
            target={target}
            rel="noreferrer"
          >
            {iconLayouts.includes(layout) ? icon : label}
          </a>
        );
      }
      return (
        <Link
          title={label}
          className={className}
          to={href || ""}
          target={target}
        >
          {iconLayouts.includes(layout) ? icon : label}
        </Link>
      );
  }
};

Button.defaultProps = {
  layout: "solid",
  colorStyle: "primary",
};

export default Button;
